"use client"

import { Separator, Text } from "@/elements"
import useOutsideClick from "@/hooks/useOutsideClick"
import { HelpCircle } from "@/icons/outline"
import { ZendeskAPI } from "@/providers/ZenDesk"
import { LifebuoyIcon, UserIcon } from "@heroicons/react/24/outline"
import Link from "next/link"
import React, { Dispatch, SetStateAction, useCallback } from "react"

interface Props {
  onToggleMenu: Dispatch<SetStateAction<boolean>>
  onSignOut: () => void
  onSwitchAccount: () => void
  showLiveChat?: boolean
  showProBadge: boolean
}

export const SETTING_MENU_ID = "settings-nav-menu"

export const SettingsMenu: React.FC<Props> = ({
  onToggleMenu,
  showProBadge,
  onSignOut,
  onSwitchAccount,
  showLiveChat = true,
}) => {
  const handler = useCallback(() => {
    onToggleMenu(false)
  }, [onToggleMenu])

  useOutsideClick(SETTING_MENU_ID, handler)

  return (
    <div
      id={SETTING_MENU_ID}
      className="ourtl flex w-[255px] flex-col gap-2 rounded-md border border-bg-3 bg-bg-1 px-3 py-3 shadow-[0_8px_20px_rgba(0,0,0,0.07)]">
      <Link href="/settings/account">
        <div className="flex w-full cursor-pointer flex-row items-center rounded-md p-2 hover:bg-bg-2">
          <UserIcon className="shrink-0" height={22} />
          <div className="flex w-full items-center justify-between gap-1 pl-2">
            <Text variant="body1">Account</Text>
            {showProBadge ? (
              <span
                className="rounded-[2px] p-1"
                style={{
                  fontSize: 11,
                  lineHeight: "8px",

                  fontWeight: 500,
                  background: "linear-gradient(134deg, #D1C3FB 0%, #D1B8EF 48.56%, #E8B6C4 100%)",
                }}>
                Pro
              </span>
            ) : null}
          </div>
        </div>
      </Link>

      <Link
        href="/settings/help-support"
        className="flex cursor-pointer flex-row items-center rounded-md p-2 hover:bg-bg-2">
        <LifebuoyIcon height={22} />
        <div className="pl-2">
          <Text variant="body1">Help & support</Text>
        </div>
      </Link>

      {showLiveChat && (
        <div
          onClick={() => {
            ZendeskAPI("messenger", "open")
          }}
          className="hidden cursor-pointer flex-row items-center rounded-md p-2 hover:bg-bg-2 md:flex">
          <HelpCircle height={22} />
          <div className="pl-2">
            <Text variant="body1">Live chat</Text>
          </div>
        </div>
      )}

      <div className="">
        <Separator />
      </div>

      <div onClick={onSwitchAccount} className="relative cursor-pointer rounded-md p-2 hover:bg-bg-2">
        <Text variant="body1">Switch account type</Text>
      </div>

      <div onClick={onSignOut} className="cursor-pointer rounded-md p-2 hover:bg-bg-2">
        <Text variant="body1">Logout</Text>
      </div>
    </div>
  )
}
